module.exports = __webpack_public_path__ + "assets/img/Lokyata-Landing-Page-+-Website.7b0ad553.jpg";